import { Component, OnInit, inject } from '@angular/core';
import { LdwRouterService } from '../../route/ldw-router.service';
import { InfoService } from '../../shared/services/info.service';

@Component({
    selector: 'ldw-scan-page',
    templateUrl: './scan-page.component.html',
    styleUrls: ['./scan-page.component.css'],
    standalone: false
})
export class ScanPageComponent implements OnInit {
  private router = inject(LdwRouterService);
  private infoService = inject(InfoService);

  ngOnInit(): void {
    this.infoService.clearStatus();
  }

  onCodeResult(found: string) {
/*    if (found.startsWith('http')) {
      found = '100_'; // fake valid token
    } */
    this.router.navigateToSearch(found, true);
  }
}
